var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
var SvgInventoryIcon = function (props) { return (_jsxs("svg", __assign({ width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M27.167 2.667H5.833c-1.333 0-2.666 1.2-2.666 2.666v4.014c0 .96.573 1.786 1.333 2.253v15.067c0 1.466 1.467 2.666 2.667 2.666h18.666c1.2 0 2.667-1.2 2.667-2.666V11.6c.76-.467 1.333-1.293 1.333-2.253V5.333c0-1.466-1.333-2.666-2.666-2.666Zm-1.334 24H7.167V12h18.666v14.667Zm1.334-17.334H5.833v-4h21.334v4Z", fill: "#fff" }), _jsx("path", { d: "M20.5 16h-8v2.667h8V16Z", fill: "#fff" })] }))); };
var Memo = memo(SvgInventoryIcon);
export default Memo;
//# sourceMappingURL=InventoryIcon.js.map